import { render, staticRenderFns } from "./TransactionsExpense.vue?vue&type=template&id=22856c89&"
import script from "./TransactionsExpense.vue?vue&type=script&lang=js&"
export * from "./TransactionsExpense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports